import { useState, type FormEvent } from "react";

const SUBMIT_ADDR = "https://readdy.ai/api/form/dahgtn3p14a1h3mr6mg0";

export default function NewsletterForm() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const payload = new FormData(form);

    const honeypot = String(payload.get("contact_alt") ?? "").trim();
    if (honeypot) {
      setStatus("success");
      setMessage("订阅成功，新一期吃瓜情报上线后会第一时间发到你的邮箱。");
      form.reset();
      return;
    }

    const body = new URLSearchParams();
    payload.forEach((value, key) => {
      const text = String(value).trim();
      if (key === "contact_alt" && text === "") return;
      if (text !== "") body.append(key, text);
    });

    setStatus("loading");
    setMessage("");

    try {
      const response = await fetch(SUBMIT_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });

      const responseText = await response.text();
      let parsed: { code?: string; message?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || "";
      const isSuccess = response.ok && parsed?.code === "OK";
      const looksLikeSpam = /spam/i.test(serverMsg);

      if (isSuccess && !looksLikeSpam) {
        setStatus("success");
        setMessage("订阅成功，新一期吃瓜情报上线后会第一时间发到你的邮箱。");
        form.reset();
      } else {
        setStatus("error");
        setMessage(
          serverMsg && !looksLikeSpam
            ? serverMsg
            : "订阅暂时没有提交成功，请稍后再试一次。",
        );
      }
    } catch {
      setStatus("error");
      setMessage("网络似乎不太稳定，请稍后再试一次。");
    }
  };

  return (
    <form
      id="newsletter-form-chigua"
      data-readdy-form
      onSubmit={handleSubmit}
      className="w-full"
      noValidate={false}
    >
      <div className="flex flex-col gap-3 sm:flex-row">
        <div className="flex-1">
          <label htmlFor="newsletter-email" className="sr-only">
            邮箱地址
          </label>
          <input
            id="newsletter-email"
            type="email"
            name="email"
            required
            placeholder="你的邮箱地址"
            className="w-full rounded-md border border-background-300 bg-background-50 px-4 py-3 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-500 focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
          />
        </div>
        <button
          type="submit"
          disabled={status === "loading"}
          className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-70"
        >
          {status === "loading" ? "提交中..." : "订阅吃瓜情报"}
        </button>
      </div>

      <input
        className="form-field-extra"
        type="text"
        name="contact_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
      />

      {status !== "idle" && message && (
        <p
          role="status"
          className={`mt-3 flex items-start gap-2 text-xs leading-relaxed ${
            status === "success" ? "text-secondary-700" : "text-primary-700"
          }`}
        >
          <span className="mt-0.5 inline-flex h-4 w-4 items-center justify-center">
            <i className={status === "success" ? "ri-checkbox-circle-line" : "ri-error-warning-line"} />
          </span>
          {message}
        </p>
      )}
    </form>
  );
}